import { proxy, useSnapshot } from 'valtio'

import { logMessage } from '../../Logging/log'

type AudienceNameState = {
  name?: string
}

const audienceNameState = proxy<AudienceNameState>({
  name: window.localStorage?.comment_name,
})

const useAudienceName = () => useSnapshot(audienceNameState).name

const setAudienceName = (name: string) => {
  try {
    audienceNameState.name = name
    window.localStorage.setItem('comment_name', name)
  } catch (error) {
    logMessage('Error setting audience name in localStorage', {
      level: 'error',
      extra: {
        cause: error,
      },
    })
  }
}

const hasAudienceName = () => !!audienceNameState.name

const getAudienceName = () => audienceNameState.name

export { useAudienceName, setAudienceName, hasAudienceName, getAudienceName }
